import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

import * as styles from './CouponBanner.module.scss'

import { EFH_COUPON } from '../../../../constants'

const translateNamespace = 'components.CatchCopy.coupon'

export const CouponBanner: React.FC = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  // すでに同じクーポンコードがURLにセットされているか（タップ済みの状態）。
  const isApplied = searchParams.get(EFH_COUPON.queryKey) === EFH_COUPON.code

  // 既存のクエリ（日程・人数など）を維持したままクーポンコードを足す。
  // パスは指定しないため現在のページ（/efh）に留まる。
  const next = new URLSearchParams(searchParams)
  next.set(EFH_COUPON.queryKey, EFH_COUPON.code)

  return (
    <Link to={{ search: `?${next.toString()}` }} className={styles.link}>
      <img
        src={EFH_COUPON.image}
        alt={t(`${translateNamespace}.alt`)}
        className={styles.image}
      />
      {isApplied ? (
        <p className={styles.applied}>{t(`${translateNamespace}.applied`)}</p>
      ) : (
        <p className={styles.lead}>{t(`${translateNamespace}.lead`)}</p>
      )}
    </Link>
  )
}
